import _ from 'lodash'
import EventBus from '@/eventBus'
import Constants from '@/constant'
import mixpanelUtils from '@/utils/mixpanel.utils'
import {
  SET_CURRENT_SLIDE_MODE,
  WINDOWED_MODE,
  EDIT_MODE,
  SET_CURRENT_ACTIVE_SLIDE,
} from '@/vuex/types'

import Socket from '@/socket'
import socketHelper from '@/helpers/socket/socket-helper'
import store from '@/vuex/store'

// configs
import Config from '@/config'

import storage from '@/services/storage'

// utils
import Utils from '@/util'
import workspace from '@/constant/workspace'

const CREATE_REACTION = 'create-reaction'

export default {
  initSocket(channel, editor) {
    Socket.subscribe(`${channel}-presenter`, (doc) => {
      this.initSocketHandler(doc, editor)
    })
  },

  initSocketHandler(doc, editor) {
    if (doc.socketId == Socket.getSocketId()) {
      return
    }
    if (doc.t === 'account-removal') {
      window.location.href = Config.accountRemovalURL
      return
    }

    if (doc.type == 'uO') {
      this._handleUserOnlineCount(editor, doc)
      return
    }

    let index
    const { presentation } = editor.$store.state

    // handle socket msg answer quiz, poll from audience
    if (doc.t == 'a') {
      // editor._checkAndUpdateHasResults()
      let indexSlideVote = null

      if (doc.s != editor.slideActive.id) {
        const indexSlideInPresentation = editor.presentation.slides.findIndex((item) => {
          return item.id == doc.s
        })

        if (indexSlideInPresentation !== -1) {
          indexSlideVote = indexSlideInPresentation
        }
      }

      if (doc.iTa) {
        this._resetTempAudienceCount(editor, doc)
        if (indexSlideVote === null) {
          editor.$store.state.tempAudienceCount++
          this.updateVoteCountThrottle(editor, doc, null)
        } else {
          editor.$store.state.presentation.slides[indexSlideVote].voteCache++
          this.updateVoteCountThrottle(editor, doc, indexSlideVote)
        }

        if (!editor.sharePresentation && editor.slideActive.type == 'pickAnswer') {
          if (editor.userOnline < 30) {
            if (editor.$store.state.audiences[doc.a]) {
              editor.$store.state.audiences[doc.a][doc.s] = true
              this._checkEveryoneVotedQuiz(editor)
            }
          }
        }
        return
      }

      if (doc.v && doc.v.length) {
        this._resetTempAudienceCount(editor, doc)

        if (indexSlideVote === null) {
          editor.$store.state.tempAudienceCount++
          this.updateVoteCountThrottle(editor, doc, null)
        } else {
          editor.$store.state.presentation.slides[indexSlideVote].voteCache++

          this.updateVoteCountThrottle(editor, doc, indexSlideVote)
        }

        this._updateSlideOptions(editor, doc)
        if (editor.presentation.audiencePacing) {
          // update chart whenever audience answers
          editor.$store.dispatch('updateSlideActive', editor.slideActive)
        }

        if (!editor.sharePresentation && editor.slideActive.type == 'pickAnswer') {
          if (editor.userOnline < 30) {
            if (editor.$store.state.audiences[doc.a]) {
              editor.$store.state.audiences[doc.a][doc.s] = true
              this._checkEveryoneVotedQuiz(editor)
            }
          }
        }
      }

      return
    }

    if (doc.type == 'question-and-answer') {
      if (doc.action == 'create') {
        // editor._checkAndUpdateHasResults()
        if (!editor.presentation.isModerationMode) {
          const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
          arr.push(doc.data)
          Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
          EventBus.$emit('questionAnimationAction')
        } else {
          editor.$store.state.questions.push(doc.data)
        }
        Utils.mixpanelTracking('Question And Answer', 'Question Received', 'Question Received')
      } else if (doc.action == 'vote' || doc.action === 'question-updated') {
        this._updateQuestionAnswer(editor, doc.data)
      }
    }

    // using both channel
    if (doc.type == 'slide' && doc.data.id == editor.slideActive.id) {
      const { data } = doc

      const payload = {
        type: doc.type,
        layout: doc.layout,
        multipleChoice: data.multipleChoice,
        limitChoice: data.limitChoice,
        typeChart: data.typeChart || 'barChart',
        hideResult: data.hideResult,
        addCorrectOption: data.addCorrectOption,
        stopSubmission: data.stopSubmission,
        showAllBulletPoints: data.showAllBulletPoints,
        image: data.image,
        imageCaption: data.imageCaption,
        youtubeLink: data.youtubeLink,
        backgroundImage: data.backgroundImage,
        textColour: data.textColour,
        baseColour: data.baseColour,
        visibility: data.visibility,
        showQuestionImage: data.showQuestionImage,
      }

      if (!editor.sharePresentation) {
        payload.showCorrectOption = doc.data.showCorrectOption
      }

      editor.updateSlideActiveAction(payload)
    }

    if (doc.type == 'presentation') {
      if (
        doc.action == 'nextSlide' &&
            !editor.sharePresentation &&
            !editor.$store.state.isDisableEditPresentation
      ) {
        if (!store.getters.isPresenting &&
          (store.state.presentation.accountId || store.state.presentation.hasSharedUser)) {
          return
        }
        if (doc.data.id == editor.slideActive.id) return
        const index = editor.presentation.slides.findIndex(
          (item) => {
            return item.id == doc.data.id
          },
        )
        editor.$store.dispatch('checkSlideMovingDirectionAction', doc.data.id)
        editor.$store.dispatch('updateSlideActive', {
          activeTab: null,
          id: null,
        })
        setTimeout(() => {
          editor.$store.dispatch(
            'setSlideActive',
            editor.presentation.slides[index],
          )

          EventBus.$emit('eventHandleSetValueTransition')
        }, 0)
      }

      if (doc.action == 'uniqueAccessCode') {
        editor.$store.state.presentation.qrcode = doc.data.qrcode
        editor.$store.state.presentation.uniqueAccessCode =
              doc.data.uniqueAccessCode
        editor.$store.state.presentation.shareCode = doc.data.shareCode
      }

      if (doc.action == 'changeAccessCode') {
        editor.$store.state.presentation.accessCode = doc.data.accessCode
      }

      if (doc.action == 'presenting') {
        // (Collab)Khi take-over present thì các user còn lại sẽ chuyển thành viewer
      }

      const isMSTeamInParam = !!Utils.getParamValue(
        'ms-teams',
        window.location.href,
      )

      if (doc.action == 'presenting' && !editor.sharePresentation) {
        if (editor.$store.state.isPreview || doc.data.presentFromPPT) return

        editor.$store.state.presentation.presenting = doc.data.presentation.presenting

        // sửa thành tất cả các tabs present cùng nhau
        // để có thể khắc phục tình trạng 1 máy đang present
        // nhưng 1 tab khác edit thì màn hình đang present sẽ không được update
        // theo và nhảy lung tung mà don't know why.
        if (!editor.$store.state.isDisableEditPresentation) {
          if (doc.data.presentation.presenting) {
            editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
          } else if (isMSTeamInParam) {
            // Khi đang edit bên AhaSlides tab thì cần alert user cần reload để lấy bản mới nhất cho bên MS Teams tab.
            // Do không phải cái gì cũng realtime update sang bên MS Teams tab.
            editor.isShowMSTeamsReloadModal = true
          } else {
            editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
          }
        }
      }

      if (doc.action === 'update-canvas-blocks' && doc.data && doc.data.canvasBlocks) {
        editor.updateSlideByIdAction({
          id: doc.data.slideId,
          canvasBlocks: doc.data.canvasBlocks,
          canvasBlocksUrl: doc.data.canvasBlocksUrl,
        })
      }

      if (doc.action == 'privateMode') {
        editor.$store.state.presentation.privateMode = doc.data.presentation.privateMode
      }

      if (doc.action === 'presentation-update' && doc.socketId !== Socket.getSocketId()) {
        const newPayload = {}
        Object.keys(doc.data).forEach((key) => {
          const oldValue = doc.data[key]
          let newValue = oldValue
          if (typeof oldValue === 'string') {
            if (oldValue === 'true') {
              newValue = true
            }
            if (oldValue === 'false') {
              newValue = false
            }
          }
          newPayload[key] = newValue
        })
        editor.$store.dispatch('updatePresentation', newPayload)
      }
    }

    if (doc.type === 'user-online-count') {
      if (doc.data || doc.data === 0) {
        if (doc.data > editor.userOnline) {
          EventBus.$emit('userOnlineCount')
          if (editor.isPresenting && !editor.sharePresentation) {
            editor.updatePresentationSessionOnlineCount(editor.presentation.id, doc.data)
          }
        }

        editor.onlineCount = doc.data
        this._handleOnlineCountThrottled(editor)
        if (!editor.maxOnlineCount || editor.onlineCount > editor.maxOnlineCount) {
          editor.maxOnlineCount = editor.onlineCount
        }
      }

      if (doc.off) {
        if (editor.$store.state.audiences[doc.off]) {
          editor.$store.state.audiences[doc.off].offline = true
          const offlineAudience = editor.$store.state.audiences[doc.off]
          if (editor.presentation.teamPlay) {
            editor._getAndSetPayloadAudienceTeamName(offlineAudience)
          }
          editor.audienceChangeStatusAction(offlineAudience)
        }

        if (editor.userOnline < 60 && editor.slideActive.type == 'pickAnswer'
              && editor.slideActive.quizStatus == Constants.QuizStatuses.LOBBY_SCREEN) {
          editor._getAudienceOnlineJoinQuiz()
        }
      }
    }

    if (doc.type == 'slideOption' && doc.action == 'audience-create') {
      // editor._checkAndUpdateHasResults()
      if (editor.slideActive.type === 'openEnded') {
        if (editor.slideActive.id === doc.data.slideId) {
          EventBus.$emit('new-open-ended-response', doc.data)
        }

        return
      }

      const matchSlide = editor.presentation.slides.find((slide) => slide.id === doc.data.slideId)
      if (!matchSlide) return

      const newSlideOptions = [...matchSlide.SlideOptions, doc.data]
      editor.patchSlideByIdAction({
        id: doc.data.slideId,
        SlideOptions: newSlideOptions,
      })
    }

    if (
      doc.type == 'slideWordCloud' &&
          doc.action == 'audience-wordcloud'
    ) {
      // editor._checkAndUpdateHasResults()
      if (doc.data.slideId == editor.slideActive.id) {
        const newSlideOptions = editor.slideActive.SlideOptions.concat(doc.data.options)
        editor.updateSlideActiveAction({
          SlideOptions: newSlideOptions,
        })

        EventBus.$emit('audienceWordCloud')
      } else {
        index = Utils.getIndexSlide(presentation.slides, doc.data.slideId)
        if (index != -1) {
          presentation.slides[index].SlideOptions = presentation.slides[
            index
          ].SlideOptions.concat(doc.data.options)
        }
      }
    }

    if (doc.type == 'active-one-time') {
      editor.$store.state.currentUser.oneTimeEnd = doc.data
      return
    }

    if (doc.type == 'export-status') {
      if (store.getters.isTreatmentShareV2) {
        editor.$store.dispatch('onlyPatchPresentationAction', { exportData: doc.exportData })
      } else {
        editor.$store.dispatch('updatePresentation', { exportData: doc.exportData })
      }

      const isExportImage = store.getters.isTreatmentShareV2 && store.state.exportingType === 'image' && doc.exportData.status === 'success'
      const isExportPdf = store.getters.isTreatmentShareV2 && store.state.exportingType === 'pdf' && doc.exportData.status === 'success'
      const isExportExcel = store.getters.isTreatmentShareV2 && store.state.exportingType === 'excel' && doc.exportData.excelStatus === 'success'
      if (isExportImage) {
        Utils.downloadFile(doc.exportData.zipUrl)
        EventBus.$emit('export-image:success', doc.exportData)
        store.state.loadingExportImage = false
      }
      if (isExportPdf) {
        Utils.downloadFile(doc.exportData.pdfUrl)
        EventBus.$emit('export-pdf:success', doc.exportData)
        store.state.loadingExportPdfV2 = false
      }
      if (isExportExcel) {
        Utils.downloadFile(doc.exportData.excelUrl)
        EventBus.$emit('export-excel:success', doc.exportData)
        store.state.loadingExportExcelV2 = false
      }
      store.state.exportingType = null
      return
    }

    if (doc.type === 'quiz-show-answer' && editor.sharePresentation) {
      if (editor.slideActive.id === parseInt(doc.data.slideId, 10)) {
        EventBus.$emit('eventShowQuizTypeAnswer')
      }
      return
    }

    if (doc.type === 'aLQT') {
      this._handleChangeQuizTeam(editor, doc.data)
      EventBus.$emit('gamelobby-leave-team', doc.data)
      editor._setTeamData()
    }

    if (doc.t === 'sca') {
      // editor._checkAndUpdateHasResults()
      this._resetTempAudienceCount(editor, doc)
      editor.$store.state.tempAudienceCount++
      this._handleAudienceScaleQuestionThrottled()
      this.updateVoteCountForScaleThrottle(editor)
    }

    if (doc.type === 'opentok') {
      if (doc.action === 'stop-call') {
        if (editor.$store.state.voiceCall.audienceUnique === doc.data.audienceUnique) {
          EventBus.$emit('stop-video-call')
        }
      }
    }
  },
  _resetTempAudienceCount(editor, doc) {
    if (!editor.slideActive.multipleCountAnswer) {
      if (editor.slideActive.id != doc.s) {
        //
      } else {
        editor.updateSlideActiveAction({
          multipleCountAnswer: 0,
        })
        editor.$store.state.tempAudienceCount = 0
      }
    }
  },
  _handleUserOnlineCount(editor, socketData) {
    const doc = {
      data: {
        audience: socketData.data.a,
        audienceName: socketData.data.n,
        audienceEmoji: socketData.data.e,
        quizOnline: socketData.data.q,
        audienceTeam: socketData.data.t,
      },
    }
    if (socketData.i) {
      doc.data.data = {
        id: socketData.data.i,
        answer: socketData.data.r,
      }
    }

    const params = {
      audience: doc.data.audience,
      audienceEmoji: doc.data.audienceEmoji,
      audienceName: doc.data.audienceName,
      offline: doc.data.offline,
      audienceTeam: doc.data.audienceTeam,
    }

    const objAudience = editor.$store.state.audiences[params.audience]
    if (!objAudience) {
      editor.$store.state.audiences[params.audience] = params
    } else {
      if (objAudience.audienceName !== params.audienceName) {
        editor.$store.state.audiences[params.audience].audienceName = params.audienceName
      }
      if (objAudience.audienceEmoji !== params.audienceEmoji) {
        editor.$store.state.audiences[params.audience].audienceEmoji = params.audienceEmoji
      }
      if (objAudience.audienceTeam !== params.audienceTeam) {
        editor.$store.state.audiences[params.audience].audienceTeam = params.audienceTeam
      }
      if (objAudience.offline !== params.offline) {
        editor.$store.state.audiences[params.audience].offline = params.offline
      }

      if (doc.data.data) {
        if (
          editor.$store.state.audiences[params.audience][doc.data.data.id] !== true
        ) {
          editor.$store.state.audiences[params.audience][doc.data.data.id] = doc.data.data.answer
        }
      }
    }

    if (editor.isQuizLobbyScreen || editor.isQuizResultScreen || editor.slideActive.type === 'qrcode') {
      editor._getAudienceOnlineJoinQuiz()
      if (editor.$store.state.presentation.teamPlay) {
        editor._getAndSetPayloadAudienceTeamName(params)
      }
      editor.audienceChangeStatusAction(params)
    }
    if (editor.$store.state.slideActive.type === 'spinnerWheel' && editor.$store.state.slideActive.wheelStatus !== 'spinning') {
      editor._handleEventAudienceOnOff()
    }
  },

  _handleAudienceScaleQuestionThrottled: _.throttle(() => {
    EventBus.$emit('scaleQuestionAnswer')
  }, 1000),

  updateVoteCountForScaleThrottle: _.throttle((editor) => {
    editor.updateSlideActiveAction({
      multipleCountAnswer: editor.$store.state.tempAudienceCount,
    })
  }, 250),

  _updateQuestionAnswer(editor, question) {
    const index = editor.$store.state.questions.findIndex((item) => {
      return item.id == question.id
    })
    if (index === -1) {
      editor.$store.state.questions.push(question)
    } else {
      editor.$store.state.questions[index] = question
    }
    const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
    Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
  },

  _handleChangeQuizTeam(editor, data) {
    if (editor.$store.state.audiences[data.a]) {
      delete editor.$store.state.audiences[data.a]
    }
  },

  _handleOnlineCountThrottled: _.throttle((editor) => {
    editor.$store.state.userOnline = editor.onlineCount

    if (editor.$store.state.currentUser.id) {
      if (!editor.$store.state.sharePresentation) {
        const percentLimit =
          (editor.$store.state.userOnline / editor.$store.state.plan.limit) *
          100
        if (percentLimit > 75 && percentLimit < 95) {
          editor.$store.state.onlineStatus = 2
        }
        if (percentLimit >= 95) {
          editor.$store.state.onlineStatus = 3
        }
        if (percentLimit <= 75 && editor.$store.state.onlineStatus != 1) {
          editor.$store.state.onlineStatus = 1
        }
      } else {
        editor.$store.state.onlineStatus = 1
      }

      mixpanelUtils.trackHostingEvent({
        presentation: editor.presentation,
        onlineCount: editor.onlineCount,
        maxOnlineCount: editor.maxOnlineCount,
      })
    }
  }, 1000),

  updateVoteCountThrottle: _.throttle((editor, doc, index) => {
    const { s: slideId } = doc
    const payload = {
      id: slideId,
      multipleCountAnswer: editor.$store.state.tempAudienceCount,
    }
    if (index !== null) {
      payload.multipleCountAnswer = editor.presentation.slides[index].voteCache
    }

    editor.patchSlideByIdAction(payload)
  }, 250),

  _updateSlideOptions(editor, doc) {
    const { s: slideId, v: votedSlideOptionIds } = doc

    const matchSlide = editor.presentation.slides.find((slide) => slide.id === slideId)
    if (!matchSlide) return

    const newSlideOptions = matchSlide.SlideOptions.map((slideOption) => {
      const hasVoted = votedSlideOptionIds.some((item) => item === slideOption.id)

      if (hasVoted) {
        const currentCount = slideOption.count || 0
        return {
          ...slideOption,
          count: currentCount + 1,
        }
      }

      return slideOption
    })

    editor.patchSlideByIdAction({
      id: slideId,
      SlideOptions: newSlideOptions,
    })
  },

  _checkEveryoneVotedQuiz(editor) {
    if (editor.$store.state.slideActive.type !== 'pickAnswer') {
      return
    }
    if (editor.$store.state.slideActive.quizStatus !== Constants.QuizStatuses.QUESTION_SCREEN) {
      return
    }

    let someoneHaveNotVote = false

    Object.keys(editor.$store.state.audiences).forEach((key) => {
      const audience = editor.$store.state.audiences[key]
      const audienceNotAnswer = !audience[editor.$store.state.slideActive.id]
      if (audienceNotAnswer) {
        someoneHaveNotVote = true
      }
    })
    if (!someoneHaveNotVote) {
      EventBus.$emit('everyone-voted')
    }
  },

  disconnectSocket(editor) {
    socketHelper.leaveRoomPresentation(editor.presentation.uniqueAccessCode)
    socketHelper.leaveRoomSlide(editor.presentation.uniqueAccessCode, editor.slideActive.id)

    Socket.getSocket().off('socket:online')
    Socket.getSocket().off('socket:offline')
    Socket.getSocket().off('presenter-takeover')
    Socket.getSocket().off('create-idea')
    Socket.getSocket().off('vote-idea')
    Socket.getSocket().off('presenter-removed')
    Socket.getSocket().io.off('reconnect')
    Socket.getSocket().off('add-slides')
    Socket.getSocket().off('presentation:report_generated')
    Socket.getSocket().off('backstage-control')
    Socket.off(CREATE_REACTION)
    Socket.off('patch-presentation')
    Socket.getSocket().off('conversation-presenter-share')

    Socket.unSubscribe(editor.$store.state.presentation.uniqueAccessCode)
    Socket.unSubscribe(`${editor.$store.state.presentation.uniqueAccessCode}-presenter`)
    Socket.unSubscribe(`user-${editor.$store.state.currentUser.id}`)
  },

  handleSocketEvent(editor) {
    Socket.getSocket().io.on('reconnect', () => this._handleOnReconnect(editor))

    Socket.getSocket().on('socket:online', (doc) => this._handleSocketOnline(editor, doc))
    Socket.getSocket().on('socket:offline', (doc) => this._handleSocketOffline(editor, doc))
    Socket.getSocket().on('presenter-takeover', (doc) => this._handleTakeOverEvent(editor, doc))
    Socket.getSocket().on('create-idea', (doc) => this._handleAudienceCreateIdeaEvent(editor, doc))
    Socket.getSocket().on('vote-idea', (doc) => this._handleAudienceVoteIdeaEvent(editor, doc))
    Socket.getSocket().on('presenter-removed', (doc) => this._handleRemovePresenterEvent(editor, doc))
    Socket.getSocket().on('add-slides', (doc) => this._handleAddSlides(editor, doc))
    Socket.getSocket().on('presentation:report_generated', (doc) => this._handleUpdateReport(editor, doc))
    Socket.getSocket().on('backstage-control', (doc) => this._handleBackstageControl(editor, doc))
    Socket.getSocket().on('conversation-presenter-share', (doc) => this._handleCommentPresentation(editor, doc))
    Socket.on(CREATE_REACTION, (doc) => this._handleCreateReaction(editor, doc))
    Socket.on('patch-presentation', (doc) => this._handlePatchPresentation(editor, doc))
  },

  trackingJoinPresentation: _.debounce((presenter, presentation, sockets) => {
    const arrKeySocketIds = Object.keys(sockets)
    if (arrKeySocketIds.length <= 0) {
      return
    }

    const userSockets = {}
    let countEditor = 0
    let countViewer = 0
    arrKeySocketIds.forEach((socketId) => {
      const userInfo = sockets[socketId]
      if (!userSockets[userInfo.id]) {
        userSockets[userInfo.id] = {
          ...userInfo,
          socketId,
        }
        if (userInfo.accountRole === workspace.VIEWER) {
          countViewer++
        } else {
          countEditor++
        }
      }
    })

    const keyStorage = `collab-user-count-${presentation.id}`
    const countUser = Object.keys(userSockets).length
    const oldCountUserCollab = storage.getValue(keyStorage, 0)
    if (oldCountUserCollab >= countUser || countUser <= 1) {
      return
    }
    storage.setValue(keyStorage, countUser)
    Utils.trackGA4AndMixpanel('Join co-editing session', {
      eventAction: 'Join co-editing session',
      presentationId: presentation.id,
      teamId: presentation.accountId,
      editorCount: countEditor,
      viewerCount: countViewer,
    })
  }, 3000),

  _handleSocketOnline(editor, doc) {
    this.trackingJoinPresentation(doc.presenter, editor.presentation, JSON.parse(JSON.stringify(editor.sockets)))
    if (!editor.sockets[doc.socketId] || !editor.sockets[doc.socketId].id) {
      editor.sockets[doc.socketId] = doc.presenter
      editor.joinCollaborativeEditingRoom(editor.presentation)
    }
    this.refreshEditor(editor)
  },

  _handleSocketOffline(editor, doc) {
    // Skip on shared screen
    if (editor.$route.name === 'PresentationShare') return

    delete editor.sockets[doc.socketId]
    this.refreshEditor(editor)
  },

  refreshEditor(editor) {
    const presenters = []
    Object.keys(editor.sockets).forEach((k) => {
      const socket = editor.sockets[k]
      const idx = presenters.findIndex((p) => { return p.id === socket.id })
      if (idx === -1) {
        socket.isMyData = socket.id == editor.currentUser.id
        if (socket.id == editor.currentUser.id && editor.isGuestUser) {
          // Demo mode, show you as Guest
          socket.name = 'Guest'
        }
        presenters.push(socket)
      }
    })

    presenters.sort((a, b) => {
      if (editor.presentation.takenOverBy === a.id) return -1
      if (editor.presentation.takenOverBy === b.id) return 1
      if (a.id < b.id) return -1
      if (a.id > b.id) return 1
      return 0
    })

    editor.$store.state.presentationEditors = presenters
    if (editor.presentation.takenOverBy) {
      editor.$store.state.isDisableEditPresentation =
      editor.presentation.takenOverBy && editor.currentUser.id !== editor.presentation.takenOverBy
    }
  },

  _handleBackstageControl(editor, payload) {
    const { socketId, type, data } = payload
    if (socketId === Socket.getSocketId()) return
    // Only update for other screens
    if (type === 'update-slide-active') {
      editor.updateSlideActiveAction(data)
      if (data.quizStatus === 5 || data.showCorrectOption) {
        editor._handleShowResultsOnQuizSlide()
      }
    } else if (type === 'start-quiz-on-other-screen') {
      EventBus.$emit('start-quiz-on-other-screen', data)
    } else if (type === 'backstage-control: hints') {
      if (data === 'show-hints') {
        EventBus.$emit('canvas-hints: show-hints-from-backstage')
      } else if (data === 'close-hints') {
        EventBus.$emit('canvas-hints: close-from-backstage')
      } else if (data.eventName === 'next-back-hints') {
        EventBus.$emit('canvas-hints: next-back-from-backstage', data.mode, data.swiperActiveIndex)
      }
    } else if (type === 'reload') {
      // Backstage: Whenever reload quiz on origin screen
      // -> set quiz scene to Lobby on other screens
      if (editor.slideActive.type === 'pickAnswer') {
        const updatedSlide = {
          quizStatus: Constants.QuizStatuses.LOBBY_SCREEN,
        }
        editor.updateSlideActiveAction(updatedSlide)
        updatedSlide.socketId = Socket.getSocketId()
        updatedSlide.accessCode = editor.$store.state.presentation.uniqueAccessCode
        updatedSlide.presentationId = editor.$store.state.presentation.id
        // if
        // updatedSlide.presenting = editor.$store.getters.isPresenting || editor.isBackstage
        editor.$http
          .put(Config.api.updateSlide + editor.$store.state.slideActive.id, updatedSlide)
          .then(() => {
          }, () => {})
      }
    } else if (type === 'acceptTypeAnswer') {
      EventBus.$emit('accept-other-type-answers-from-backstage')
    }
  },

  async _handleTakeOverEvent(editor, doc) {
    if (editor.currentUser.id === editor.presentation.takenOverBy &&
      doc.takenOverBy !== editor.currentUser.id) {
      Object.keys(editor.sockets).forEach((k) => {
        const socket = editor.sockets[k]

        if (doc.takenOverBy === socket.id) {
          editor.tookOverPresenter = socket
          editor.presentation.TakenOverByUser = socket
        }
      })

      if (!editor.isMSTeamsApp) {
        EventBus.$emit('clearOtherPopups')
        setTimeout(() => {
          editor.isShowBeTakenOverModal = true
        }, 300)
      }
    }

    editor.presentation.takenOverBy = doc.takenOverBy

    this.refreshEditor(editor)

    // AHA-5372 Presenting > Khi đang presenting và bị take over, presenter đó chưa được chuyển về màn hình Editor
    if (doc.takenOverBy != editor.currentUser.id) {
      if (editor.isMSTeamsApp) {
        editor.isShowMSTeamsReloadModal = true
        return
      }
      editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      editor.$router.replace({
        name: 'PresentationDetail',
        params: {
          id: editor.$store.state.presentation.id,
          beTakenOver: true,
        },
      })
    } else {
      await editor.getDataPresentationDetail({ cachedContentSlides: false })

      // This is a hack. We should not doeditor.
      const currentSlideId = editor.$store.state.slideActive.id
      if (currentSlideId) {
        editor.$store.dispatch('updateSlideActive', {
          activeTab: null,
          id: null,
        })
        setTimeout(() => {
          editor.$store.dispatch(SET_CURRENT_ACTIVE_SLIDE, currentSlideId)
          EventBus.$emit('eventHandleSetValueTransition')
        }, 0)
      }
    }
  },

  _handleAudienceCreateIdeaEvent(editor, doc) {
    // editor._checkAndUpdateHasResults()
    const matchSlide = editor.presentation.slides.find((slide) => slide.id === doc.slideId)

    if (!matchSlide
      || !matchSlide.SlideOptions
      || matchSlide.SlideOptions.length >= Constants.MAX_IDEAS_NUMBER) {
      return
    }

    let newSlideOptions = [...editor.slideActive.SlideOptions, doc]
    newSlideOptions = newSlideOptions
      .map((idea, index) => ({ ...idea, createdAtOrder: index + 1 }))

    editor.patchSlideByIdAction({
      id: doc.slideId,
      SlideOptions: newSlideOptions,
    })

    if (doc.slideId === editor.slideActive.id) {
      EventBus.$emit('handleSortIdeasByCreatedAt')
    }

    EventBus.$emit('handleScrollingAndShowScroll')
  },

  _handleAudienceVoteIdeaEvent: _.throttle((editor, doc) => {
    const index = editor.slideActive.SlideOptions.findIndex((option) => {
      return option.id === doc.slideOptionId
    })
    if (index === -1) return
    editor.slideActive.SlideOptions[index].votesCount = doc.numberOfVotes
    editor.updateSlideActiveAction(editor.slideActive)
  }, 300),

  _handleRemovePresenterEvent(editor, doc) {
    const { removedPresenters } = doc
    if (removedPresenters.indexOf(editor.currentUser.email) > -1) {
      Utils.showToastError(this.$i18nPresenter.t('You have been removed from this presentation'))
      window.setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  },

  _handleAddSlides(editor, payload) {
    const slideTypes = {}
    Constants.allTypeSections.forEach((item) => {
      item.slideTypes.forEach((typeObj) => {
        slideTypes[typeObj.type] = typeObj
      })
    })

    payload.slides.forEach((item) => {
      if (item.type) {
        item.typeObj = slideTypes[item.type]
      }
    })

    editor.$store.state.presentation.slides = editor.$store.state.presentation.slides.concat(
      payload.slides,
    )
  },

  async _handleOnReconnect(editor) {
    // khi bỏ check if 2 dòng code bên dưới sẽ xảy ra vấn đề khi
    // reconect trong khi đang chơi quiz sẽ bị lỗi, có thể còn nhiều lỗi khác
    if (!store.getters.isPresenting) {
      editor.sockets = {}
      await editor.getDataPresentationDetail()
      editor.joinCollaborativeEditingRoom(editor.presentation)
    }
  },

  _handleUpdateReport(editor, payload) {
    editor.patchPresentationAction({
      exportData: {
        ...editor.presentation.exportData,
        ...payload,
      },
    })
  },

  _handleCreateReaction: _.throttle((editor, message) => {
    const { audienceName, reactionType, ...partialPresentation } = message
    editor.patchPresentationAction(partialPresentation)
    // editor._checkAndUpdateHasResults()
    EventBus.$emit(CREATE_REACTION, { audienceName, reactionType })
  }, 200),

  _handlePatchPresentation(editor, payload) {
    // Reactions already set state, set again will results in flickering
    // https://ahaslides.atlassian.net/browse/AHA-7788
    if (payload.reactions) return
    editor.patchPresentationAction(payload)
  },

  async _handleCommentPresentation(editor, doc) {
    if (doc.type === 'new-message' && doc.data.socketId !== Socket.getSocketId()) {
      EventBus.$emit('presentation-new-comment', doc.data)
    }
  },
}
